export default "__VITE_ASSET__486dca24__"